// extracted by mini-css-extract-plugin
export var button = "button-module--button--9ad72";
export var outlined = "button-module--outlined--505c2";
export var primary = "button-module--primary--05a0e";
export var secondary = "button-module--secondary--5068f";